module.exports = __webpack_public_path__ + "img/gzh.777f6d15.jpg";